import { z } from 'zod';
import { donorProfileSchemaFields, validateDonorProfileRequiredFields } from '@features/forms/DonorProfileForm';
import { DonorProfileFormValues } from '@features/forms/DonorProfileForm/types';
import { DonorType, OrganType } from '@/api/apis/case';

export type EditDonorProfileFormValues = DonorProfileFormValues & {
  organType: OrganType;
  donorType: DonorType;
};

export const editDonorProfileSchema = z
  .object({
    ...donorProfileSchemaFields,
    organType: z.enum(OrganType),
    donorType: z.enum(DonorType),
  })
  .superRefine(validateDonorProfileRequiredFields);
